export default __webpack_public_path__ + "static/media/AddUserIcon.b994f21c.svg";